module.exports = __webpack_public_path__ + "img/address.eb84530d.svg";